import styled, { css } from 'styled-components';
import { LAYOUT_TYPE } from '@/app/components/search/components/LayoutManager/utils.ts';

export const SearchPageMain = styled.main<{
  layoutType: LAYOUT_TYPE;
  evolutionEnabled?: boolean;
}>`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 1;

  ${({ layoutType }) =>
    layoutType === LAYOUT_TYPE.MOBILE_MAP &&
    css`
      z-index: 2;
    `};

  ${({ evolutionEnabled }) =>
    evolutionEnabled &&
    css`
      margin-bottom: 48px;
    `};
`;
